import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isCaltexApp } from 'src/app/utility/caltex-receipt-logic';

interface DialogData {
  dialogMode: boolean;
}

@Component({
  selector: 'app-receipt-submission-confirmation',
  templateUrl: './receipt-submission-confirmation.component.html',
  styleUrl: './receipt-submission-confirmation.component.scss',
})
export class ReceiptSubmissionConfirmationComponent {
  isCaltex = isCaltexApp();
  submitClaim: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogRef: MatDialogRef<ReceiptSubmissionConfirmationComponent>,
  ) {}

  submit() {
    this.submitClaim = true;
    const claim = this.submitClaim;
    this.dialogRef.close({ claim });
  }
}
